<template>
  <div class="container-fluid mt-3">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">Datos de la empresa</h3>
            </div>
          </div>
          <div class="card-body">
            <form ref="profile_form" @submit.prevent="handleProfileUpdate">
              <div class="row">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                        label="CIF"
                        prepend-icon="fas fa-building"
                        placeholder="CIF"
                        v-model="empresa.cif"
                      />
                      <validation-error :errors="apiValidationErrors.cif" />
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        label="Razón social"
                        prepend-icon="fas  fa-building"
                        placeholder="Razón social"
                        v-model="empresa.razonSocial"
                      />
                      <validation-error
                        :errors="apiValidationErrors.razonSocial"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                        label="Dirección"
                        prepend-icon="fas fa-building"
                        placeholder="Dirección"
                        v-model="empresa.direccion"
                      />
                      <validation-error
                        :errors="apiValidationErrors.direccion"
                      />
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        label="Ciudad"
                        prepend-icon="fas fa-building"
                        placeholder="Ciudad"
                        v-model="empresa.ciudad"
                      />
                      <validation-error :errors="apiValidationErrors.ciudad" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                        label="Provincia"
                        prepend-icon="fas fa-building"
                        placeholder="Provincia"
                        v-model="empresa.provincia"
                      />
                      <validation-error
                        :errors="apiValidationErrors.provincia"
                      />
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        label="Código postal"
                        prepend-icon="fas fa-building"
                        placeholder="Código postal"
                        v-model="empresa.codigo_postal"
                      />
                      <validation-error
                        :errors="apiValidationErrors.codigo_postal"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                        label="País"
                        prepend-icon="fas fa-building"
                        placeholder="País"
                        v-model="empresa.pais"
                      />
                      <validation-error :errors="apiValidationErrors.pais" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="my-2 text-right">
                <base-button
                  type="button"
                  class="btn btn-sm btn-primary"
                  native-type="submit"
                >
                  Actualizar datos de empresa
                </base-button>
              </div>
            </form>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import BaseInput from "@/components/Inputs/BaseInput.vue";
import BaseButton from "@/components/BaseButton.vue";
import formMixin from "@/mixins/form-mixin";
import ValidationError from "@/components/ValidationError.vue";
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";

export default {
  name: "UserEditCard",

  components: {
    BaseInput,
    BaseButton,
    ValidationError,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  mixins: [formMixin],

  /*  props: {
    user: Object,
  }, */

  data() {
    return {
      image: null,
      file: null,
      available_roles: [],
      empresa: {
        type: "empresas",
        cif: null,
        razonSocial: null,
        direccion: null,
        ciudad: null,
        provincia: null,
        codigo_postal: null,
        pais: null,
      },
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        await this.$store.dispatch("profile/me");
        let profile = await this.$store.getters["profile/me"];

        console.log(profile);
        const id = profile.empresas[0].id;
        await this.$store.dispatch("empresas/get", id);

        this.empresa = await this.$store.getters["empresas/empresa"];

        console.log(this.empresa);
      } catch (error) {
        console.log(error);
        this.$notify({
          type: "danger",
          message: "Oops, ha habido un error",
        });
        this.setApiValidation(error.response.data.errors);
      }
    },

    removeImage() {
      this.image = null;
    },

    async handleProfileUpdate() {
      console.log(this.empresa);

      try {
        await this.$store.dispatch("empresas/update", this.empresa);
        this.$notify({
          type: "success",
          message: "Empresa actualizada correctamente.",
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Oops, ha habido un error",
        });
        console.log(error);
        console.log(error.response.data.errors);
        this.setApiValidation(error.response.data.error.details.errors);
      }
    },
  },
};
</script>
